(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'BucketItem',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.success = function success(response)
	{
		if (!Adzuki.Form.hasError(response)) {
			Adzuki.StatusMessage('Success', 'The item(s) have been added to your bucket');

			$('.modal').modal('hide');
		}

		return false;
	};

	form.error = function error()
	{
		Adzuki.StatusMessage('Error', 'Error saving bucket item');
		return false;
	};

}(jQuery, window.Adzuki || {}));
